import React from 'react';
import PropTypes from 'prop-types';
import { HeadingBanner } from 'anf-core-react';

const HeadingBannerTitle = (
  {
    brandText, viewAllStoresUrl, storeText, viewAllStoresText,
  },
) => (
  <HeadingBanner variant="boxed">
    <h2>
      {brandText.value}
      {storeText.value.substring(3)}
    </h2>
    <span className="view-all-stores">
      <a id="single-store__view-all-stores-link" href={viewAllStoresUrl} data-property={viewAllStoresText.key}>{viewAllStoresText.value}</a>
    </span>
  </HeadingBanner>
);

HeadingBannerTitle.propTypes = {
  brandText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  viewAllStoresUrl: PropTypes.string.isRequired,
  storeText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  viewAllStoresText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};

export default HeadingBannerTitle;
